<template>
  <div class="flex flex-wrap items-center justify-end gap-2">
    <Button
      size="small"
      severity="secondary"
      outlined
      icon="pi pi-copy"
      :label="t('messages.transactions.analytics.result.copy')"
      :disabled="store.exporting"
      data-testid="txn-analytics-copy"
      @click="copy"
    />
    <Button
      size="small"
      icon="pi pi-file-excel"
      :label="t('messages.transactions.analytics.result.export')"
      :loading="store.exporting"
      data-testid="txn-analytics-export"
      @click="exportExcel"
    />
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { useToast } from 'primevue/usetoast'
import { useAnalyticsStore } from '@/stores/analyticsStore'

/**
 * RED-310 — actions above the result table: TSV copy to the clipboard and
 * the server-side .xlsx export. Both live in the store; this component only
 * turns their outcome into a toast (the store never toasts — see the
 * PrimeVue skill: feedback is wired in the component).
 */
const { t } = useI18n()
const toast = useToast()
const store = useAnalyticsStore()

const copy = async () => {
  const copied = await store.copyTsv()
  toast.add({
    severity: copied ? 'success' : 'error',
    summary: t(`messages.transactions.analytics.result.${copied ? 'copied' : 'copy_failed'}`),
    life: 3000,
  })
}

const exportExcel = async () => {
  try {
    await store.exportExcel()
  } catch (_error) {
    toast.add({
      severity: 'error',
      summary: t('messages.transactions.analytics.result.export_failed'),
      life: 4000,
    })
  }
}
</script>
